// extracted by mini-css-extract-plugin
module.exports = {"page":"ErrorLabel_page__383E2","content":"ErrorLabel_content__2BFjL","message":"ErrorLabel_message__39XtT"};